import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, MenuItem,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../../styles/MyStyles";
import {GetClientViewName} from "../../../logic/ClientNameHelper";
import {GetClients} from "../../../logic/DataProvider";
import {GetEnumMenuItems} from "../../../logic/EnumHelper";

const NewUserPage = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [request, setRequest] = useState({
        role: '',
        contactId: ''
    });

    const [clients, setClients] = useState([]);

    useEffect(() => {
        GetClients().then((clients) => setClients(clients));
    }, []);

    const validateForm = () => {
        let newErrors = {};

        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

        if (request.role === '') {
            newErrors.role = 'Role is required.';
        }

        if (request.contactId === '') {
            newErrors.contactId = 'Contact is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        setRequest({
            ...request,
            [event.target.name]: event.target.value,
        });
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            let contact = clients.find((e) => e.id === request.contactId);
            request.email = contact.email;

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_USERS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(request),
                }
            );
            if (response.ok) {
                console.log('User created successfully.');
                handleGoBack();
            } else {
                console.log('Create request failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const getClientsMenuItems = () => {
        let items = [];
        if (clients) {
            clients.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetClientViewName(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                Create User
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Role</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="role"
                                label="Role"
                                select
                                value={request.role}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.role}
                                helperText={errors.role}
                            >
                                {GetEnumMenuItems('userRole')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Contact</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="contactId"
                                label="Contact"
                                select
                                value={request.contactId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.contactId}
                                helperText={errors.contactId}
                            >
                                {getClientsMenuItems()}
                            </TextField>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default NewUserPage;
